// extracted by mini-css-extract-plugin
export default {"table":"stepsTable_table__zUuLu","stepNameCell":"stepsTable_stepNameCell__Cm2Dq","buttons":"stepsTable_buttons__OborS"};